import { Component } from '@angular/core';

interface MissionVisionCard {
    icon: string;
    title: string;
    paragraphs: string[];
}

@Component({
    selector: 'app-mission-vision-redesign',
    templateUrl: './mission-vision-redesign.component.html',
    styleUrls: ['./mission-vision-redesign.component.scss']
})
export class MissionVisionRedesignComponent {

    cards: MissionVisionCard[] = [
        {
            icon: '/assets/img/redesign/about/mission-icon.png',
            title: 'MISSION',
            paragraphs: [
                'Our mission is to develop clinical AI technology that helps healthcare institutions detect risks earlier, coordinate care teams more effectively and improve patient monitoring.',
                'Althea Soft is built for institutional environments where safety, privacy, clinical responsibility and operational efficiency are essential.',
                'We do not aim to replace clinical judgement. We aim to strengthen it with timely data, intelligent alerts and a clearer view of the patient across the care pathway.'
            ]
        },
        {
            icon: '/assets/img/redesign/about/vision-icon.png',
            title: 'VISION',
            paragraphs: [
                'AltheaCare is not merely a platform, it is the foundation for a new era where mental health disorders are anticipated and prevented rather than managed.',
                'By harnessing predictive intelligence, collaborative infrastructure, and human-centric AI, AltheaCare empowers healthcare leaders to deliver superior outcomes, enhance provider satisfaction, and build resilient, sustainable mental health ecosystems.'
            ]
        }
    ];

    trackByTitle(index: number, card: MissionVisionCard): string {
        return card.title;
    }

    trackByIndex(index: number): number {
        return index;
    }

}